import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

const formatPeriod = (value, viewType) => {
    if (!value) return "-";

    switch (viewType) {
        case "monthly":
            return dayjs(value, "MM-YYYY").format("MMM YYYY");

        case "daily":
            return dayjs(value, "DD-MM-YYYY").format("Do MMM YYYY");

        case "weekly": {
            const [start, end] = value.split(" to ");

            const startDate = dayjs(start, "DD-MM-YYYY").format("Do MMM");
            const endDate = dayjs(end, "DD-MM-YYYY").format("Do MMM");

            return `${startDate} to ${endDate}`;
        }

        default:
            return value;
    }
};

export const transformPeriodData = (data = [], viewType) => {

    const periodSet = new Set();
    const grouped = {};

    data.forEach((item) => {

        const period = formatPeriod(item.period, viewType);

        periodSet.add(period);

        if (!grouped[item.section]) {
            grouped[item.section] = {};
        }

        if (!grouped[item.section][item.description]) {
            grouped[item.section][item.description] = {};
        }

        grouped[item.section][item.description][period] = item.value;
    });

    const periods = Array.from(periodSet);

    return { grouped, periods };
};


export const sectionOrder = [
    "Safe Manhours",
    "Incident",
    "Training",
    "Safety Meeting",
    "Reward & Recognition",
    "Monitoring & Measurement",
    "Finding Tracker",
    "Environment Reporting",
    "Safety Resources",
];